import { faker } from '@faker-js/faker'
import { http, HttpResponse } from 'msw'

import type { GetCitiesResponse } from '@/api/locale-city/get-cities'

export const mockGetMyBusinessGetCities = http.get(
  '/my-business/api/agency/v1/locales/cities',
  async ({ request }) => {
    const requestUrl = new URL(request.url)

    const cityName = requestUrl.searchParams.get('search')
    const stateSymbol = requestUrl.searchParams.get('stateSymbol')

    if (cityName && cityName.toLowerCase() === 'caxias do sul') {
      const cities: GetCitiesResponse[] = [
        {
          cityId: faker.number.int({ min: 100, max: 999 }),
          cityName: 'Caxias do Sul',
          countryName: 'Brasil',
          countrySymbol: 'BR',
          iata: 'CXJ',
          stateName: 'Rio Grande do Sul',
          stateSymbol: 'RS',
        },
      ]

      return HttpResponse.json({ data: cities }, { status: 200 })
    }

    if (stateSymbol && stateSymbol === 'RS') {
      const cities: GetCitiesResponse[] = Array.from({ length: 50 }).map(
        () => ({
          cityId: faker.number.int({ min: 100, max: 999 }),
          cityName: faker.location.city(),
          countryName: faker.location.country(),
          countrySymbol: faker.location.countryCode(),
          iata: faker.string.alpha({ casing: 'upper', length: 3 }),
          stateName: 'Rio Grande do Sul',
          stateSymbol: 'RS',
        }),
      )

      return HttpResponse.json({ data: cities }, { status: 200 })
    }

    const cities: GetCitiesResponse[] = Array.from({ length: 50 }).map(() => ({
      cityId: faker.number.int({ min: 100, max: 999 }),
      cityName: faker.location.city(),
      countryName: faker.location.country(),
      countrySymbol: faker.location.countryCode(),
      iata: faker.string.alpha({ casing: 'upper', length: 3 }),
      stateName: 'Rio Grande do Sul',
      stateSymbol: 'RS',
    }))

    return HttpResponse.json({ data: cities }, { status: 200 })
  },
)
